import { render, staticRenderFns } from "./litgDetails.vue?vue&type=template&id=2aeae732&scoped=true&"
import script from "./litgDetails.vue?vue&type=script&lang=js&"
export * from "./litgDetails.vue?vue&type=script&lang=js&"
import style0 from "./litgDetails.vue?vue&type=style&index=0&id=2aeae732&scoped=true&lang=css&"
import style1 from "./litgDetails.vue?vue&type=style&index=1&id=2aeae732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeae732",
  null
  
)

export default component.exports